import { Component, EventEmitter, Input, Output } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-confirm-base",
  imports: [TranslateModule],
  template: "",
})
export class ConfirmBaseComponent {
  @Input("dialogTitle") dialogTitle: string = "texts.Modal_Confirm_Title";
  @Input("dialogText") dialogText: string;
  @Input("dialogSubtitle") dialogSubtitle?: string;
  @Input("dialogConfirmButton") dialogConfirmButton: string =
    "texts.Modal_Confirm_Button";
  @Input("dialogCancelButton") dialogCancelButton: string =
    "texts.Modal_Confirm_Button";
  @Input("showTitle") showTitle: boolean = true;
  @Input("showSeparator") showSeparator: boolean = true;
  @Input() isTextAlignedLeft: boolean = false;
  @Output() onConfirm = new EventEmitter();
  @Output() onClose = new EventEmitter();

  showCloseButton: boolean;
  showCancelButton: boolean;

  constructor() {}
}
